// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"03e99832","40":"f2a2cf2b","57":"d0f1504f","212":"6697f9a5","333":"1ef92f15","397":"dea2c4f4","453":"04e2fcc5","787":"6abfd3e8","928":"510fac07","949":"59dc225e"}[chunkId] + ".chunk.js";
};